import { Inject, Pipe, PipeTransform } from "@angular/core";
import * as momentImport from "moment-timezone";

import {
    DATE_FORMAT,
    TIMEZONE,
} from "../tokens/index";

const moment = momentImport as any; // required for rollup to work without a TypeScript error

@Pipe({ name: "spsDate" })
export class SpsDatePipe implements PipeTransform {
    constructor(
        @Inject(DATE_FORMAT) private dateFormat,
        @Inject(TIMEZONE) private timezone,
    ) {}

    transform(date: any): string {
        if (!moment.isMoment(date)) {
            date = moment(date);
        }
        if (moment.defaultZone.abbrs.indexOf(date.zoneAbbr()) === -1) {
            date = date.clone().tz(this.timezone);
        }
        if (date.isValid()) {
            return date.format(this.dateFormat);
        }
    }
}
